import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import soundManager from "slotworks/sound/sound-manager";

export default class RespinAwardTransitions extends AbstractSceneTransition {
    public in() {
        
        return Contract.empty();
    }

    public out() {
        soundManager.customEvent("jp_transition");
        return Contract.empty();
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/respin-award-transitions.ts